var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.354,
    height: 15.192,
    viewBox: "0 0 12.354 15.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text",
    transform: "translate(-3.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13897",
    "data-name": "Path 13897",
    d: "M11.1,2H5.419A1.419,1.419,0,0,0,4,3.419V14.773a1.419,1.419,0,0,0,1.419,1.419h8.515a1.419,1.419,0,0,0,1.419-1.419V6.258Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13898",
    "data-name": "Path 13898",
    d: "M14,2V6.258h4.258",
    transform: "translate(-2.904)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_447",
    "data-name": "Line 447",
    x1: 5.995,
    transform: "translate(6.569 10.197)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_448",
    "data-name": "Line 448",
    x1: 5.995,
    transform: "translate(6.569 12.767)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13899",
    "data-name": "Path 13899",
    d: "M9.419,9H8",
    transform: "translate(-1.162 -2.033)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesOpenIcon);
export default __webpack_public_path__ + "static/media/NotesOpenIcon.9254aed55076f5afd9f3c62d6079c573.svg";
export { ForwardRef as ReactComponent };